import React from "react";
import {
  Stack,
  IStackTokens,
  Text,
  DirectionalHint,
  Breadcrumb,
  DefaultButton,
  FocusTrapZone,
  Calendar,
  DayOfWeek,
  Callout,
  IIconProps,
  PrimaryButton,
} from "office-ui-fabric-react";
import { Loading } from "../../../services/Loading";
import { mdiDotsVertical } from "@mdi/js";
import Icon from "@mdi/react";
import {
  childrenGap,
  childrenGap8,
  DayPickerStrings,
} from "../../common/Constants";
import { ToastContext } from "../../common/ToastProvider";
import { IMergedCustomers } from "../../../vm";
import { getMergedCustomers } from "../../../services/merged-customers/MergedCustomerService";
import ManageMergedCustomerDialog from "./ManageMergedCustomerDialog";
import { useHistory, useParams } from "react-router-dom";
import moment from "moment";
import { Card } from "@uifabric/react-cards";
import { GS } from "../../../utils/Styles";
import { downloadCustomerReport } from "../../../services/customers/CustomerService";
import { b64toBlob } from "../../../services/UtilService";

export interface ViewMergedCustomerProps {}

let calendarButtonElement: HTMLElement;

const ViewMergedCustomer: React.FC<ViewMergedCustomerProps> = () => {
  // custom hooks
  const { showToast } = React.useContext(ToastContext);
  const history = useHistory();
  const params: any = useParams();
  const cardTokens: any = { childrenMargin: 16 };
  const childrenGap24: IStackTokens = { childrenGap: 24 };
  const editIcon: IIconProps = { iconName: "Edit" };
  const downloadIcon: IIconProps = { iconName: "DownloadDocument" };

  // state
  const [isLoading, setLoading] = React.useState(false as boolean);
  const [mergedCustomer, setMergedCustomer] = React.useState({} as IMergedCustomers);
  const [manageDialog, setManageDialog] = React.useState({
      isOpen: false,
      data: undefined
  } as {
      isOpen: boolean;
      data?: IMergedCustomers;
    })
  // const [manageActionsCallout, setManageActionsCallout] = React.useState({
  //     isOpen: false,
  //     element: undefined,
  // } as {
  //     isOpen: boolean;
  //     element: any;
  //   });
   const [search, setSearch] = React.useState({
     customerIds: [],
     datacenterIds: "",
     date: moment().subtract(1, "month").toDate(),
     mergedCustomerId: "",
     isSendPayload: true
   } as {
     customerIds: string[];
     datacenterIds: string;
     date: Date | string;
     mergedCustomerId: string;
     isSendPayload: boolean;
   });
   const [showCalender, setShowCalender] = React.useState(false as boolean);

  // hooks
  React.useEffect(() => {
    const asyncFunc = async () => {
        await getAMergedCustomer();
    }
    asyncFunc();
  }, [])

  const getAMergedCustomer = async () => {
      setLoading(true);
      const result = await getMergedCustomers({ mergedCustomerId: params.mergedCustomerId });
      if (result?.success && result.data?.mergedCustomers && result.data.mergedCustomers.length > 0) {
        const customer = result.data.mergedCustomers[0];
        const customerIds: string[] = [];
        let datacenterIds: string[] = [];
        customer.mergedCustomers.forEach((d) => {
            customerIds.push(d.customerId);
            datacenterIds = [ ...datacenterIds, ...d.datacenterIds ];
        });
        setMergedCustomer(customer);
        setSearch({ ...search, datacenterIds: datacenterIds.join(","), customerIds, mergedCustomerId: customer._id as string });
      } else {
        showToast(result?.message || "Error while getting merged customer details", "error");
      }
      setLoading(false);
  }

  // const handleCallOutOpenClose = (
  //   isOpen: boolean,
  //   ele?: React.MouseEvent<HTMLSpanElement>,
  // ) => {
  //     setManageActionsCallout({
  //       isOpen,
  //       element: isOpen ? ele?.currentTarget : undefined,
  //     })
  // };

  const handleDialogOpen = (isOpen: boolean) => {
    setManageDialog({
        isOpen,
        data: mergedCustomer,  
    });
  };

  const handleDialogClose = (data: IMergedCustomers) => {
    let mergedCustomers = { ...mergedCustomer };
    if (data) {
      mergedCustomers = { ...mergedCustomers, ...data };
      showToast("Merged Customer updated successfully", "success");
    }
    setManageDialog({
        isOpen: false,
        data: undefined,
    });
    setMergedCustomer(mergedCustomers);
  };

  const downloadReport = async () => {
    setLoading(true);
    let searchObj = { ...search };
    searchObj.date = moment(searchObj.date).format("YYYY-MM-DD");
    const result = await downloadCustomerReport(searchObj);
    const pptxFile  = await b64toBlob(result.data,"application/vnd.openxmlformats-officedocument.presentationml.presentation");
    const pptxFileUrl = window.URL.createObjectURL(pptxFile);
    const downloadLink = document.createElement("a");
    const name =
      mergedCustomer.name.replace(/\./g, "") +
      " " +
      mergedCustomer.datacenterNames +
      " " +
      moment(search.date).format("MMM-YYYY");
    const fileName = `${name}.pptx`;
    downloadLink.href = pptxFileUrl;
    downloadLink.download = fileName;
    downloadLink.click();
    setLoading(false);
  }

  return (
      <React.Fragment>
        {isLoading && <Loading isModeless={true} />}
        <Stack tokens={childrenGap}>
          <Stack.Item>
                <Breadcrumb
                    items={[
                    {
                        text: "Merged Customers",
                        key: "merged-customers",
                        onClick: () => {
                        history.push(`/customers/merged`);
                        },
                    },
                    {
                        text: `${mergedCustomer.name}`,
                        key: "name",
                        isCurrentItem: true,
                    },
                    ]}
                />
          </Stack.Item>
          <Stack.Item>
             <Card
                    className="ms-motion-scaleDownIn card-width"
                    horizontal
                    styles={{ root: { ...GS.bgWhite } }}
                    tokens={cardTokens}
                  >
                    <Card.Section className="m-0 padding-16" grow={1}>
                        <Stack wrap tokens={childrenGap}>
                            <Stack.Item>
                                <Stack horizontal horizontalAlign="space-between" wrap tokens={childrenGap}>
                                    <Stack.Item>
                                        <Text className="merged-customer-title">{mergedCustomer.name}</Text>
                                    </Stack.Item>
                                    <Stack.Item>
                                        {/* <span
                                        onClick={(ele) => handleCallOutOpenClose(true, ele)}
                                       >
                                        <Icon
                                        path={mdiDotsVertical}
                                        size={0.9}
                                        className="pointer"
                                        color="#135c8a"
                                        />
                                      </span> */}
                                      <Stack wrap tokens={childrenGap} horizontal>
                                        <Stack.Item>
                                          <DefaultButton
                                            text="Edit"
                                            onClick={() => handleDialogOpen(true)}
                                            iconProps={editIcon}
                                          />
                                        </Stack.Item>
                                        <Stack.Item>
                                        <div
                    ref={(calendarBtn) =>
                      (calendarButtonElement = calendarBtn!)
                    }
                  >
                    <DefaultButton
                      text={
                        !search.date
                          ? "Select a month"
                          : moment(search.date).format("MMM-YYYY")
                      }
                      onClick={() =>
                        setShowCalender(true)
                      }
                      className="month-picker-btn"
                    />
                  </div>
                  {showCalender && (
                    <Callout
                      isBeakVisible={false}
                      // className="ms-DatePicker-callout"
                      gapSpace={0}
                      doNotLayer={false}
                      target={calendarButtonElement}
                      directionalHint={DirectionalHint.bottomLeftEdge}
                      onDismiss={() => setShowCalender(false)}
                      setInitialFocus
                    >
                      <FocusTrapZone
                        firstFocusableSelector="ms-DatePicker-day--today"
                        isClickableOutsideFocusTrap
                      >
                        <Calendar
                          // eslint-disable-next-line react/jsx-no-bind
                          onSelectDate={(date: Date | null | undefined) => {
                            setSearch({
                              ...search,
                              date: date as any,
                            });
                            setShowCalender(false);
                          }}
                          onDismiss={() => setShowCalender(false)}
                          isMonthPickerVisible={true}
                          value={search.date as Date}
                          firstDayOfWeek={DayOfWeek.Sunday}
                          strings={DayPickerStrings}
                          isDayPickerVisible={false}
                          highlightCurrentMonth={false}
                          highlightSelectedMonth={true}
                          showMonthPickerAsOverlay={false}
                          showGoToToday={false}
                          maxDate={moment().subtract(1, "month").toDate()}
                        />
                      </FocusTrapZone>
                    </Callout>
                  )}
                                        </Stack.Item>
                                        <Stack.Item>
                                        <PrimaryButton
                                            text="Download Report"
                                            onClick={downloadReport}
                                            iconProps={downloadIcon}
                                          />
                                        </Stack.Item>
                                      </Stack>
                                    </Stack.Item>
                                </Stack>
                            </Stack.Item>
                            <Stack.Item>
                                <Stack wrap tokens={childrenGap24} className="pl-16">
                                    {mergedCustomer?.mergedCustomers?.map((d) => (
                                        <Stack.Item>
                                            <Stack wrap tokens={childrenGap8}>
                                                <Stack.Item>
                                                    <Text className="merged-customer-sub-title">{d.customerName}</Text>
                                                </Stack.Item>
                                                <Stack.Item>
                                                    <Text className="merged-customer-dc">{d.datacenterName}</Text>
                                                </Stack.Item>
                                            </Stack>
                                        </Stack.Item>
                                    ))}
                                </Stack>
                            </Stack.Item>
                        </Stack>
                    </Card.Section>
                  </Card>
          </Stack.Item>
        </Stack>
        {/* {manageActionsCallout.isOpen && (
        <Callout
          styles={{ root: { width: 175, padding: 20 } }}
          role="alertdialog"
          ariaLabelledBy={
            mergedCustomer && mergedCustomer._id
          }
          gapSpace={0}
          target={manageActionsCallout.element}
          directionalHint={DirectionalHint.leftCenter}
          onDismiss={() => handleCallOutOpenClose(false)}
        >
          <Stack tokens={childrenGap8}>
            <Stack.Item className="pointer">
              <span
                onClick={() => {
                  handleDialogOpen(true);
                }}
                className="callout-options"
              >
                Edit
              </span>
            </Stack.Item>
            <Stack.Item className="pointer">
              <span
                onClick={undefined}
                className="callout-options"
              >
                Download Report
              </span>
            </Stack.Item>
          </Stack>
        </Callout>
      )} */}
        {manageDialog.isOpen && (
            <ManageMergedCustomerDialog data={manageDialog.data} handleDialogClose={(data: IMergedCustomers) => handleDialogClose(data)} />
        )}
      </React.Fragment>
  )
};

export default ViewMergedCustomer;
